// Action Types
export const FETCH_ICDS_REQUEST = 'FETCH_ICDS_REQUEST';
export const FETCH_ICDS_SUCCESS = 'FETCH_ICDS_SUCCESS';
export const FETCH_ICDS_FAILURE = 'FETCH_ICDS_FAILURE';

export const CREATE_ICD_REQUEST = 'CREATE_ICD_REQUEST';
export const CREATE_ICD_SUCCESS = 'CREATE_ICD_SUCCESS';
export const CREATE_ICD_FAILURE = 'CREATE_ICD_FAILURE';

export const UPDATE_ICD_REQUEST = 'UPDATE_ICD_REQUEST';
export const UPDATE_ICD_SUCCESS = 'UPDATE_ICD_SUCCESS';
export const UPDATE_ICD_FAILURE = 'UPDATE_ICD_FAILURE';

export const DELETE_ICD_REQUEST = 'DELETE_ICD_REQUEST';
export const DELETE_ICD_SUCCESS = 'DELETE_ICD_SUCCESS';
export const DELETE_ICD_FAILURE = 'DELETE_ICD_FAILURE';

export const FETCH_ICD_RULES_REQUEST = 'FETCH_ICD_RULES_REQUEST';
export const FETCH_ICD_RULES_SUCCESS = 'FETCH_ICD_RULES_SUCCESS';
export const FETCH_ICD_RULES_FAILURE = 'FETCH_ICD_RULES_FAILURE';

export const MAP_ICD_TO_RULE_REQUEST = 'MAP_ICD_TO_RULE_REQUEST';
export const MAP_ICD_TO_RULE_SUCCESS = 'MAP_ICD_TO_RULE_SUCCESS';
export const MAP_ICD_TO_RULE_FAILURE = 'MAP_ICD_TO_RULE_FAILURE';

export const DELETE_ICD_RULE_MAPPING_REQUEST = 'DELETE_ICD_RULE_MAPPING_REQUEST';
export const DELETE_ICD_RULE_MAPPING_SUCCESS = 'DELETE_ICD_RULE_MAPPING_SUCCESS';
export const DELETE_ICD_RULE_MAPPING_FAILURE = 'DELETE_ICD_RULE_MAPPING_FAILURE';

// Action Creators
export const fetchIcdsRequest = ( options = {}) => {
    const { page = 1, limit = 1, search = '' } = options;
    return {
        type: FETCH_ICDS_REQUEST,
        payload: { page, limit, search },
        
      }; 
    }; 
export const fetchIcdsSuccess = (icds) => ({ type: FETCH_ICDS_SUCCESS, payload: icds });
export const fetchIcdsFailure = (error) => ({ type: FETCH_ICDS_FAILURE, payload: error });

export const createIcdRequest = (data) => ({ type: CREATE_ICD_REQUEST, payload: data });
export const createIcdSuccess = (icd) => ({ type: CREATE_ICD_SUCCESS, payload: icd });
export const createIcdFailure = (error) => ({ type: CREATE_ICD_FAILURE, payload: error });

export const updateIcdRequest = (id, data) => ({ type: UPDATE_ICD_REQUEST, payload: { id, data } });
export const updateIcdSuccess = (icd) => ({ type: UPDATE_ICD_SUCCESS, payload: icd });
export const updateIcdFailure = (error) => ({ type: UPDATE_ICD_FAILURE, payload: error });

export const deleteIcdRequest = (id) => ({ type: DELETE_ICD_REQUEST, payload: id });
export const deleteIcdSuccess = (id) => ({ type: DELETE_ICD_SUCCESS, payload: id });
export const deleteIcdFailure = (error) => ({ type: DELETE_ICD_FAILURE, payload: error });

export const fetchIcdRulesRequest = (projectId, icdId) => ({ type: FETCH_ICD_RULES_REQUEST, payload: { projectId, icdId } });
export const fetchIcdRulesSuccess = (rules) => ({ type: FETCH_ICD_RULES_SUCCESS, payload: rules });
export const fetchIcdRulesFailure = (error) => ({ type: FETCH_ICD_RULES_FAILURE, payload: error });

export const mapIcdToRuleRequest = (projectId, icdId, ruleId) => ({ type: MAP_ICD_TO_RULE_REQUEST, payload: { projectId, icdId, ruleId } });
export const mapIcdToRuleSuccess = () => ({ type: MAP_ICD_TO_RULE_SUCCESS });
export const mapIcdToRuleFailure = (error) => ({ type: MAP_ICD_TO_RULE_FAILURE, payload: error });

export const deleteIcdRuleMappingRequest = (projectId, icdId, ruleId) => ({ type: DELETE_ICD_RULE_MAPPING_REQUEST, payload: { projectId, icdId, ruleId } });
export const deleteIcdRuleMappingSuccess = () => ({ type: DELETE_ICD_RULE_MAPPING_SUCCESS });
export const deleteIcdRuleMappingFailure = (error) => ({ type: DELETE_ICD_RULE_MAPPING_FAILURE, payload: error });
